import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  user: any;
  isAuthenticated: boolean;
  token: string | null;
  role: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  role: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.role = action.payload.role;
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    logout: state => {
      state.user = null;
      state.isAuthenticated = false;
    }
  }
});

export const { setUser, logout, setToken } = authSlice.actions;

export default authSlice.reducer;
